module.exports = __webpack_public_path__ + "img/auth.7bc2bdd5.png";